<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-carousel cycle="false" height="500" max="400">
          <v-carousel-item
            v-for="(item,i) in images"
            :key="i"
            :src="item.src"
            reverse-transition="fade"
            transition="fade"
          ></v-carousel-item>
        </v-carousel>

        <div style="margin:20px;">
          <span style="margin:20px; font-weight:bold;">Disponibilidad</span>
        </div>

        <v-flex xs12 sm6 class="my-3">
          <div class="subheading"></div>
          <v-date-picker
            v-model="date1"
            :events="blockeddays"
            event-color="red lighten-1"
            locale="es-es"
            :first-day-of-week="1"
            header-color="blue"
          ></v-date-picker>
        </v-flex>

        <v-flex sm2 xs6 class="text-sm-left text-xs-center"></v-flex>

        <v-flex sm2 xs6 class="text-sm-right text-xs-right"></v-flex>
        <v-flex sm2 xs6 class="text-sm-right text-xs-right">
          <v-btn @click="saveData()">Guardar equipo</v-btn>
        </v-flex>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card>
          <v-card-text>
            <v-flex xs12 md12>
              <v-text-field
                v-model="macdata.machinename"
                :rules="nameRules"
                :counter="50"
                label="Nombre"
                required
              ></v-text-field>
            </v-flex>
            <v-select
              v-model="macdata.machinebrandid"
              :items="brands"
              item-text="brandname"
              item-value="brandid"
              label="Marca"
            ></v-select>
            <v-flex xs12 md12>
              <v-text-field
                v-model="macdata.machinedescription"
                :rules="nameRules"
                :counter="100"
                label="Descripción"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                v-model="macdata.machinemodel"
                :rules="nameRules"
                :counter="30"
                label="Modelo"
                required
              ></v-text-field>
            </v-flex>
            <v-divider></v-divider>
            <div class="text-sm-left text-xs-left">
              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machineprice"
                  :rules="nameRules"
                  :counter="50"
                  label="Precio (€)"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machinepriceexcess"
                  :rules="nameRules"
                  :counter="50"
                  label="Fianza (€)"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machinepower"
                  :rules="nameRules"
                  :counter="50"
                  label="Potencia (CV)"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md12>
                <v-text-field
                  v-model="macdata.machineplace"
                  :rules="nameRules"
                  :counter="50"
                  label="Localización"
                  required
                  readonly="true"
                ></v-text-field>
              </v-flex>

              <google-map />

              <v-flex xs12 md12>
                <v-text-field
                  v-model="macdata.machinelocation"
                  :rules="nameRules"
                  :counter="50"
                  label="Coordenadas"
                  required
                  readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machineyear"
                  :rules="nameRules"
                  :counter="50"
                  label="Año de fabricación"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machinetacometer"
                  :rules="nameRules"
                  :counter="50"
                  label="Horas de uso "
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machineserialnumber"
                  :rules="nameRules"
                  :counter="50"
                  label="Número de bastidor "
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  v-model="macdata.machineplatenumber"
                  :rules="nameRules"
                  :counter="50"
                  label="Matrícula "
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md10>
                <v-slider
                  v-model="macdata.machinediscount1"
                  :rules="rules"
                  label="Descuento 15-30 dias"
                  step="1"
                  :max="40"
                  :min="0"
                  ticks
                  thumb-label="always"
                ></v-slider>
              </v-flex>

              <v-flex xs12 md10>
                <v-slider
                  v-model="macdata.machinediscount2"
                  :rules="rules"
                  label="Descuento 30-60 dias"
                  step="1"
                  :max="40"
                  :min="0"
                  ticks
                  thumb-label="always"
                ></v-slider>
              </v-flex>

              <v-flex xs12 md10>
                <v-slider
                  v-model="macdata.machinediscount3"
                  :rules="rules"
                  label="Descuento más de 60 dias"
                  step="1"
                  :max="40"
                  :min="0"
                  ticks
                  thumb-label="always"
                ></v-slider>
              </v-flex>

              <!-- <li v-for="(ingredient, i) in item.recipe.ingredientLines" :key="i">{{ingredient}}</li> -->
            </div>
            <v-checkbox
              class="text-sm-left text-xs-left custom-checkbox"
              label="Transporte disponible"
              :value="true"
              :input-value="hasTransport"
            ></v-checkbox>
            <v-checkbox
              class="text-sm-left text-xs-left custom-checkbox"
              label="Seguro disponible"
              :value="true"
              :input-value="hasInsurance"
            ></v-checkbox>
          </v-card-text>
          <v-card-title></v-card-title>
        </v-card>
        <v-card class="py-8 my-8">
          <div class="custom-checkbox mb-8" v-for="(itemx, index) in attsType4">
            <v-checkbox
              class="text-sm-left text-xs-left custom-checkbox"
              style="font-size:12;"
              :label="itemx.labelx"
              :value="true"
              :input-value="itemx.valuebool"
            ></v-checkbox>
          </div>
          <span > -</span>
        </v-card>


        
        <v-card>
          <div
            class="text-sm-left text-xs-left custom-machineatt"
            v-for="(itemx, index) in attsType3"
          >
            <v-layout row wrap>
              <v-flex d-flex xs6>
                <v-card tile flat>
                  <span
                    height="30"
                    class="text-sm-left text-xs-left custom-check"
                  >{{itemx.label}} : {{itemx.value}}</span>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-card>

        <v-card class="my-8  py-8">
          <div class="custom-machineatt"></div>
          <div
            class="text-sm-left text-xs-left custom-machineatt"
            v-for="(itemx, index) in attsType1"
          >
            <v-flex xs12 md6>
              <v-text-field class="py-n4" filled v-model="itemx.value" :label="itemx.label "></v-text-field>
            </v-flex>
            <!--   <span class="text-sm-left text-xs-left custom-check">{{itemx.label}} : {{itemx.value}}</span> -->
          </div>
                    <span> -</span><br>
          <span>- </span>

        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GoogleMap from "../../components/Maps/GoogleMap";
import { EventBus } from "../../eventBus";

export default {
  name: "MachineDetail",
  props: ["id"],

  data() {
    return {
      images: [],
      uuid: "",
      macdata: {},
      machinePhotos: [],
      isLoading2: false,
      hasTransport: false,
      hasInsurance: false,
      attsType1: [],
      attsType2: [],
      attsType3: [],
      attsType4: [],
      selectedBrand: null,
      caltype: "month",
      calstart: "2019-07-12",
      calend: "2020-01-06",
      blockeddays: ["2019-07-16", "2019-07-17"],
      currentMonth: 7,
      date: null,
      brands: [],
      attributes: []
    };
  },
  mounted: function() {
    //this.getop(this.$route.query.id);
    this.uuid = this.$route.query.id;
    this.getop(this.$route.query.id);
    const _this = this;
    EventBus.$on("newAddress", addressStr => {
      _this.macdata.machineplace = addressStr;
      console.log("Address: " + addressStr);
    });

    EventBus.$on("newLocation", locatStr => {
      _this.macdata.machinelocation = locatStr;
      console.log("Address: " + locatStr);
    });

    const url2 = process.env.VUE_APP_BASE_URI + "/getbrandsbytype/1"; //+ _this.macdata.machinetypeid;
    _this.$http
      .get(url2) //this.$root.globalsapp.baseurl + "/getoperation/" + opuuid)
      .then(function(response) {
        console.log("" + response);
        _this.brands = response.data.brands;
      })
      .catch(function(error) {
        console.log(error);
        // this.isLoading2 = false;
      });
  },
  components: {
    GoogleMap
  },
  computed: {},
  methods: {
    saveData: function() {
      const _this = this;
      this.isLoading2 = true;
      var dataToSend = this.macdata;
      delete dataToSend.cultivations;
      delete dataToSend.machineattributes;
      const url = process.env.VUE_APP_BASE_URI + "/updatemachine/" + this.uuid;
      _this.$http
        .post(url, dataToSend) //this.$root.globalsapp.baseurl + "/getoperation/" + opuuid)
        .then(function(response) {
          console.log(response);
          _this.isLoading2 = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.isLoading2 = false;
        });
    },
    getop: function(opuuid) {
      const _this = this;
      this.isLoading2 = true;
      const url = process.env.VUE_APP_BASE_URI + "/getmachinebyuuid/" + opuuid;
      _this.$http
        .get(url) //this.$root.globalsapp.baseurl + "/getoperation/" + opuuid)
        .then(
          function(response) {
            console.log(response);
            this.isLoading2 = false;
            this.macdata = response.data.machinedata;
            if (this.macdata.machineinsuranceavailable == 1)
              this.hasInsurance = true;
            if (this.macdata.machinetransportavailable == 1)
              this.hasTransport = true;
            this.macdata.machineattributes.forEach(element => {
              if (element.attributetype == 1) {
                var attnew = {};
                attnew.label = element.attributename;
                attnew.value = element.attributevaluenum;
                if (element.attributename == "Potencia") var aa = 0;
                else this.attsType1.push(attnew);
              } else if (element.attributetype == 3) {
                var attnew = {};
                attnew.label = element.attributename;
                attnew.value = element.attributevaluenum;
                this.attsType3.push(attnew);
              } else if (element.attributetype == 4) {
                var attnew = {};
                attnew.labelx = element.attributename;
                if (element.attributevalueyesno == 0) attnew.valuebool = false;
                else attnew.valuebool = true;
                _this.attsType4.push(attnew);
              }
            });
            if (_this.macdata.machinelocation != null) {
              EventBus.$emit("setMacAddress", _this.macdata.machinelocation);
            }

            _this.$http
              .get(
                process.env.VUE_APP_BASE_URI +
                  "/getphotosformachine/" +
                  response.data.machinedata.machineuuid
              )
              .then(
                function(response) {
                  console.log("" + response);
                  //  this.isLoading2 = false;
                  this.machinePhotos = response.data;
                  for (var a = 0; a < this.machinePhotos.length; a++) {
                    var newimg = {};
                    newimg.src =
                      process.env.VUE_APP_BASE_URI +
                      "/getimage/" +
                      this.machinePhotos[a].imageuuid;
                    this.images.push(newimg);
                  }
                }.bind(this)
              )
              .catch(
                function(error) {
                  console.log(error);
                  // this.isLoading2 = false;
                }.bind(this)
              );
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
            this.isLoading2 = false;
          }.bind(this)
        );

      const url2 =
        process.env.VUE_APP_BASE_URI + "/getblockeddaysbyuuid/" + opuuid;
      _this.$http
        .get(url2) //this.$root.globalsapp.baseurl + "/getoperation/" + opuuid)
        .then(
          function(response) {
            console.log("" + response);
            //  this.isLoading2 = false;
            this.blockeddays = response.data.blockeddays;
            //                  for (var a = 0; a < this.machinePhotos.length; a++) {
            //                    var newimg = {};
            //                    newimg.src =
            //                      "https://ploou-produccion.appspot.com/getimage/" +
            //                      this.machinePhotos[a].imageuuid;
            //                    this.images.push(newimg);
            //                  }
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
            // this.isLoading2 = false;
          }.bind(this)
        );
    }
  }
};
</script>
<style lang="stylus">
#example-custom-transition {
  .fade {
    &-enter-active, &-leave-active, &-leave-to {
      transition: 0.3s ease-out;
      position: absolute;
      top: 0;
      left: 0;
    }

    &-enter, &-leave, &-leave-to {
      opacity: 0;
    }
  }
}

.custom-checkbox {
  height: 20px;
  font-size: 12;
  margin-left: 5px;
}

.custom-machineatt {
  height: 60px;
  font-size: 12;
  margin-left: 15px;
}

.v-label {
  font-size: 14px;
  font-color: black;
}
</style>